"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  particle {\n    border-radius: 50%;\n    left: 0;\n    pointer-events: none;\n    position: fixed;\n    top: 0;\n    opacity: 0;\n    z-index: 10000;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showParticles = exports.ParticleStyle = void 0;

var polished_1 = require("polished");

var styled_components_1 = require("styled-components");

exports.ParticleStyle = (0, styled_components_1.createGlobalStyle)(_templateObject());

function showParticles(element, opts) {
  var bounds = element.getBoundingClientRect();
  var x = bounds.x + bounds.width / 2;
  var y = bounds.y + bounds.height / 2;

  for (var i = 0; i < 30; i++) {
    createParticle(x, y, opts);
  }
}

exports.showParticles = showParticles;

function createParticle(x, y, _ref) {
  var color = _ref.color,
      _ref$maxSize = _ref.maxSize,
      maxSize = _ref$maxSize === void 0 ? 25 : _ref$maxSize,
      _ref$minSize = _ref.minSize,
      minSize = _ref$minSize === void 0 ? 5 : _ref$minSize,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 75 : _ref$radius,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1000 : _ref$duration;
  var particle = document.createElement('particle');
  document.body.appendChild(particle);
  var size = Math.floor(Math.random() * (maxSize - minSize) + minSize);
  particle.style.width = "".concat(size, "px");
  particle.style.height = "".concat(size, "px");
  particle.style.background = (0, polished_1.adjustHue)(Math.random() * 30, color);
  var destinationX = x + (Math.random() - 0.5) * 2 * radius;
  var destinationY = y + (Math.random() - 0.5) * 2 * radius;
  var animation = particle.animate([{
    transform: "translate(".concat(x - size / 2, "px, ").concat(y - size / 2, "px)"),
    opacity: 1
  }, {
    transform: "translate(".concat(destinationX, "px, ").concat(destinationY, "px)"),
    opacity: 0
  }], {
    duration: 500 + Math.random() * duration,
    easing: 'cubic-bezier(0, .9, .57, 1)',
    delay: Math.random() * 200
  });

  animation.onfinish = function () {
    particle.remove();
  };
}